<template>
    <swiper class="content" :options="swiperOption" ref="mySwiper">
        <swiper-slide></swiper-slide>
        <swiper-slide><h2>HAKKIMIZDA</h2></swiper-slide>
        <swiper-slide><h2>FAALİYET ALANLARI</h2></swiper-slide>
        <swiper-slide><h2>EKİBİMİZ</h2></swiper-slide>
        <swiper-slide><h2>YAYINLAR</h2></swiper-slide>
        <swiper-slide><h2>İLETİŞİM</h2></swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
</template>

<script>


export default {
  components: {
      
  },
  name: 'swiperx',
  data () {
    return {
        swiperOption: {
          autoplay: 3000,
        }
    }
  }
}
</script>

<style>
.swiper-container {
    height: 100%;
    background: rgba(10, 10, 10, 0.1);
}
h2 {
    font-weight: 900;
    font-size: 300%;
}
.content {
    text-align: center;
}
.content h2 {
    top: 50%;
    position: relative;
    margin-top: -20px;
    color: gainsboro;
}
</style>



// WEBPACK FOOTER //
// swiperx.vue?17f1e7cd